import { ReactNode } from 'react'
import { IWidget, WidgetConfig, WidgetDashboardConfig } from './widgetDashboard.interface'
import { WidgetTypes } from './widgetDashboard.enums'
import ChartWidget from './widgets/chartWidget/chartWidget'
import { getDefaultPane } from '../multiPane/multipPaneLayout.helper'
import OiWidget from './widgets/oiWidget/oiWidget'
import { SuperChartConfiguration_TimeBucket } from '../../proto/generated/superchart-page'
import MultiStrikeWidget from './widgets/multiStrikeWidget/multiStrikeWidget'
import OptionChainWidget from './widgets/optionChainWidget/optionChainWidget'
import { Platform } from '../../proto/generated/user-preference'
import { TradeOptions } from '../../reducer/scalper.reducer'


export const getDefaultLayout = (): WidgetDashboardConfig => {
    return {
        panes: getDefaultPane(),
        singleMode: false,
        widgets: {},
        syncSettings: {
            security: false,
            crosshair: true,
            time: false,
            timeBucket: false,
            drawing: false
        }
    }
}
export const getWidgetComponent = (dashboardId: string, {
    widgetType,
    settings,
    slotId
}: WidgetConfig<any>, ref: Record<string, IWidget>, hoveredPane: number, allowSplit?: boolean, tradeOptions?: TradeOptions): ReactNode => {
    switch (widgetType) {
        case WidgetTypes.OI_CHART:
            return <OiWidget allowSplit={allowSplit} dashboardId={dashboardId} tradeOptions={tradeOptions} slotId={slotId} settings={settings} ref={(r) => {
                if (ref) ref[slotId] = r
            }} hoveredSlotId={hoveredPane} />
        case WidgetTypes.MULTI_STRIKE_CHART:
            return <MultiStrikeWidget allowSplit={allowSplit} dashboardId={dashboardId} tradeOptions={tradeOptions} slotId={slotId} settings={settings} ref={(r) => {
                if (ref) ref[slotId] = r
            }} hoveredSlotId={hoveredPane} />
        case WidgetTypes.OPTION_CHAIN:
            return <OptionChainWidget allowSplit={allowSplit} dashboardId={dashboardId} tradeOptions={tradeOptions} slotId={slotId} settings={settings} ref={(r) => {
                if (ref) ref[slotId] = r
            }} hoveredSlotId={hoveredPane} />
        case WidgetTypes.CHART:
        case WidgetTypes.FUTURE_CHART:
        case WidgetTypes.ATM_OPTION_CHART:
        case WidgetTypes.OPTION_CHART:
            return <ChartWidget allowSplit={allowSplit} dashboardId={dashboardId} tradeOptions={tradeOptions} slotId={slotId} settings={settings} ref={(r) => {
                if (ref) ref[slotId] = r
            }} hoveredSlotId={hoveredPane} />
    }
}

export const getDefaultWidget = (dashboardId: string, slotId: number, widgetType: WidgetTypes, key: string, expressionMode: boolean, securities: string[], timeBucket?: SuperChartConfiguration_TimeBucket): WidgetConfig<any> => {
    switch (widgetType) {
        case WidgetTypes.CHART:
        default:
            return {
                slotId,
                widgetType,
                settings: {
                    chartId: `${dashboardId}-${slotId}`,
                    key,
                    securities,
                    expressionMode,
                    timeBucket
                }
            }
    }
}

export const getDashboardSlotIdFromKey = (key: string): [string, string] => {
    const [dashboardId, slotId] = key.split('-')
    return [dashboardId, slotId]
}

export const normalizePlatform = (p: Platform) => {
    switch (p) {
        case Platform.MOBILE:
        case Platform.DESKTOP:
            return p;
        default:
            return Platform.DESKTOP;
    }
}